
import { z } from "zod";

export const ParentRelationshipValues = ["REPLY", "REACTION", "COMMENT"] as const;
export const ParentRelationshipSchema = z.enum(ParentRelationshipValues);
export const ParentRelationship = ParentRelationshipSchema.enum;
export type ParentRelationship = (typeof ParentRelationshipValues)[number];
